import { Button, Form, Input, message, Spin } from "antd";
import styles from "./styles.module.scss";
import { useState } from "react";
import { InputField } from "./inputField";
import { Link, useNavigate } from "react-router-dom";
import { UseLazyApiCallV2 } from "hooks";
import { useLanguageTranslator } from "hooks/use-language-translator";
import { Trans } from "react-i18next";

export const Signup = () => {
  const { translator } = useLanguageTranslator();
  const registerTrans = translator("Register");
  const [form] = Form.useForm();
  const onFinish = (values) => {
    handleApiCall(values);
  };

  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
  });
  const [signup, { isLoading: registerLoading }] = UseLazyApiCallV2({
    url: null,
    method: "POST",
  });
  const [resendOtpFn, { isLoading: sendOtpLoading }] = UseLazyApiCallV2({
    url: "/send_otp",
    method: "POST",
  });
  const handleApiCall = async (values) => {
    try {
      const res = await signup({
        url: "/register_user",
        params: {
          email: values.email,
          password: values.password,
          firstName: values.firstName,
          lastName: values.lastName,
        },
      });

      if (res) {
        if (res.status === "SUCCESS") {
          resendOtpFn({
            params: {
              secret_id: res?.data?.secretId,
            },
          }).then((result) => {
            if (result) {
              const queryParams = new URLSearchParams();
              queryParams.set("userId", `${res?.data?.secretId}`);
              navigate(`otp-verification?${queryParams.toString()}`);
            }
          });
        } else if (res.status === "Error") {
          message.error(res.message);
        }
      }
    } catch (err) {
    } finally {
      // setButtonLoading(false);
    }
  };

  return (
    <div className={styles.signupContainer}>
      <div className={styles.formCard}>
        <div>
          <h3>{registerTrans.heading}</h3>
          <p className={styles.desc}>{registerTrans.desc}</p>
          <Spin spinning={!!registerLoading}>
            <Form
              form={form}
              name="signup"
              onFinish={onFinish}
              autoComplete="off"
              className={styles["signup-form"]}
              initialValues={{
                firstName: "",
                lastName: "",
                email: "",
                password: "",
              }}
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "20px",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "20px",
                    width: "100%",
                    justifyContent: "space-between",
                  }}
                >
                  <div style={{ width: "50%" }}>
                    <div className={styles.label}>
                      {registerTrans.firstName}
                    </div>
                    {/* First Name */}
                    <Form.Item
                      name="firstName"
                      rules={[
                        {
                          required: true,
                          message: translator("firstNameValidationErr"),
                        },
                      ]}
                    >
                      <Input
                        placeholder={registerTrans.firstName}
                        style={{ height: "52px" }}
                        maxLength={40}
                      />
                    </Form.Item>
                  </div>

                  {/* Last Name */}
                  <div style={{ width: "50%" }}>
                    <div className={styles.label}>{registerTrans.lastName}</div>

                    <Form.Item
                      name="lastName"
                      rules={[
                        {
                          required: true,
                          message: translator("lastNameValidationErr"),
                        },
                      ]}
                    >
                      <Input
                        placeholder={registerTrans.lastName}
                        style={{ height: "52px" }}
                        maxLength={40}
                      />
                    </Form.Item>
                  </div>
                </div>
                {/* Email */}
                <div>
                  <div className={styles.label}>{registerTrans.email}</div>
                  <Form.Item
                    name="email"
                    rules={[
                      {
                        type: "email",
                        required: true,
                        message: translator("emailValidationErr"),
                      },
                      // {
                      //   pattern: /^[^\s@]+@smileautovermietung\.de$/,
                      //   message: translator("onlySmileEmailAllowed"),
                      // },
                    ]}
                  >
                    <Input
                      placeholder={registerTrans.email}
                      style={{ height: "52px" }}
                      maxLength={40}
                    />
                  </Form.Item>
                </div>

                {/* Password */}
                <div>
                  <div className={styles.label}>{registerTrans.password}</div>
                  <Form.Item
                    name="password"
                    rules={[
                      {
                        required: true,
                        message: translator("passwordValidationErr"),
                      },
                    ]}
                  >
                    <Input.Password
                      placeholder={registerTrans.password}
                      style={{ height: "52px" }}
                    />
                  </Form.Item>
                </div>
              </div>

              <Button type="primary" htmlType="submit" block>
                {registerTrans.signup}
              </Button>
            </Form>
          </Spin>
          <p className={styles.termsAndPolicy}>
            <Trans
              i18nKey="Register.termsAndPolicy"
              values={{
                terms: registerTrans.terms,
                policy: registerTrans.policy,
              }}
              components={{ a: <Link to="#" />, b: <Link to="#" /> }}
            />
          </p>
        </div>
        <p className={styles.alreadyHaveAccount}>
          <Trans
            i18nKey="Register.alreadyHaveAnAccount"
            values={{ signin: registerTrans.signin }}
            components={{ a: <Link to="/" /> }}
          />
        </p>
      </div>
    </div>
  );
};
